import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

import PlansMap from './map';
import StopMarkers from './stops';
import AddressMarkers from './addresses';
import SchoolMarkers from './schools';
import DepotMarkers from './depots';
import JourneyTemplatePolylines from './journey_templates';
import Filters from './filters';
import UrlHelper from '../app/url_helper';
import initRangeSliders from '../app/rangeslider';
import cable from '../app/cable';

function closeSidebar() {
  $('.page-networks').removeClass('show-sidebar');
  $(document).trigger('gm:sidebar:hide');
}

class Plans extends Component {
  constructor(props) {
    super(props);
    this.subscriptions = [];
    this.subscriptionTimeouts = [];
    this.state = {
      mapType: 'roadmap',
      zoom: 13,
      journeyTemplates: $('#map-network-manage').data('journey-templates'),
    };

    this.onStopClick = this.onStopClick.bind(this);
    this.onJourneyTemplateClick = this.onJourneyTemplateClick.bind(this);
    this.onAddressClick = this.onObjectClick.bind(this, 'address', 'addresses');
    this.onSchoolClick = this.onObjectClick.bind(this, 'school', 'schools');
    this.onDepotClick = this.onObjectClick.bind(this, 'depot', 'depots');
    this.onClickCapture = this.onClickCapture.bind(this);
    this.onClickRelease = this.onClickRelease.bind(this);
    this.onLoad = this.onLoad.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onZoomChanged = this.onZoomChanged.bind(this);
    this.onFiltersChanged = this.onFiltersChanged.bind(this);
  }

  componentDidMount() {
    $(document).off('gm:sidebar:show.plans').on('gm:sidebar:show.plans', this.onSidebarShow.bind(this));
    $(document).off('gm:sidebar:hide.plans').on('gm:sidebar:hide.plans', this.onSidebarHide.bind(this));

    $('.gmap-btn-zoom-in').off('click').on('click', () => this.setState({ zoom: Math.min(20, this.map.getZoom() + 1) }));
    $('.gmap-btn-zoom-out').off('click').on('click', () => this.setState({ zoom: Math.max(10, this.map.getZoom() - 1) }));
    $('.gmap-btn-satelite').off('click.plans').on('click.plans', ({ currentTarget }) =>
      this.setState({ mapType: $(currentTarget).toggleClass('active').hasClass('active') ? 'satellite' : 'roadmap' }));

    this.connectChannel({ channel: 'PlanChannel', plan_id: this.props.planId }, ['stops', 'stoppable_addresses']);
    this.connectChannel({ channel: 'ClientChannel', client_id: this.props.clientId }, ['stops', 'schools', 'depots', 'students']);
  }

  componentWillUnmount() {
    $(document).off('gm:sidebar:show.plans');
    $(document).off('gm:sidebar:hide.plans');
    $('.gmap-btn-satelite').off('click.plans');

    this.disconnectChannels();
  }

  onSidebarShow() {
    this.setState({
      currentObject: $('.page-networks .window-content').data(),
      journeyTemplates: $('#map-network-manage').data('journey-templates'),
    });

    initRangeSliders();
    $('.map-sidebar .btn-close').off('click').click(() => closeSidebar());
  }

  onSidebarHide() {
    this.setState({ currentObject: null });
  }

  onStopClick(stop) {
    const handled = _.attempt(() => this.clickHandler.onStopClick(stop));
    if (!_.isError(handled) && handled) { return; }

    this.setState({ currentObject: null });
    $.getScript(UrlHelper.networkScopedUrl(`/plans/${this.props.planId}/stops/${stop.id}`));
  }

  onObjectClick(type, path, object) {
    const handled = _.attempt(() => this.clickHandler[_.camelCase(`on_${object}_click`)](object));
    if (!_.isError(handled) && handled) { return; }

    this.setState({ currentObject: null });
    $.getScript(UrlHelper.networkScopedUrl(`/plans/${path}/${object.id}?${this.props.planId ? `plan_id=${this.props.planId}` : ''}`));
  }

  onJourneyTemplateClick(journeyTemplate) {
    const handled = _.attempt(() => this.clickHandler.onJourneyTemplateClick(journeyTemplate));
    if (!_.isError(handled) && handled) { return; }

    const date = $('input#filter-date').val();
    $.getScript(new UrlHelper(
      UrlHelper.networkScopedUrl(`/plans/${this.props.planId}/journey_templates/${journeyTemplate.id}`),
    ).urlByAppendingParams({ date }));
  }

  onClickCapture(handler) {
    this.clickHandler = handler;
  }

  onClickRelease(handler) {
    if (this.clickHandler === handler) {
      this.clickHandler = null;
    }
  }

  onLoad(map) {
    if (!map) { return; }
    this.map = map;
    this.fitMapBounds();

    const overlay = new google.maps.OverlayView();
    overlay.draw = () => {};
    overlay.setMap(this.map);
    this.setState({ overlayView: overlay });
  }

  onClick() {
    closeSidebar();
  }

  fitMapBounds() {
    const b = this.props.mapBounds;
    if (!b) { return; }

    google.maps.event.addListenerOnce(this.map, 'idle', () =>
      this.setState({ zoom: _.clamp(this.map.getZoom(), 10, 16) }));
    this.map.fitBounds(new google.maps.LatLngBounds(
      { lat: b.south, lng: b.west },
      { lat: b.north, lng: b.east },
    ));
  }

  onZoomChanged() {
    if (!this.map) { return; }
    this.setState({ zoom: this.map.getZoom() });
  }

  onFiltersChanged(filters) {
    this.setState({ filters });
  }

  onChannelConnected(index, methods) {
    const subscription = this.subscriptions[index];
    if (!subscription) { return; }
    _.each(methods, (m, i) => {
      this.subscriptionTimeouts.push(setTimeout(() => {
        subscription.perform(m);
      }, i * 200));
    });
    subscription.perform('plan');
  }

  onChannelMessageReceived(index, message) {
    const subscription = this.subscriptions[index];
    if (message.type === 'plan') {
      const simulatedAt = moment(message.data.simulated_at);
      if (!simulatedAt.isValid()) { return; }
      if (!moment(this.props.simulatedAt).isSame(simulatedAt, 'second')) {
        setTimeout(() => window.history.go(0), 1000);
      }
      return;
    } else if (_.startsWith(message.type, 'destroy_')) {
      const type = _.camelCase(_.replace(message.type, 'destroy_', ''));
      this.setState({
        [type]: _.reject(this.state[type], { id: message.data.id }),
      });
      return;
    } else if (_.startsWith(message.type, 'journey_templates')) {
      this.updateObjects(subscription, message.type, _.camelCase(message.type), message.data[message.type], message.data.meta, false);
      return;
    }
    this.updateObjects(subscription, message.type, _.camelCase(message.type), message.data[message.type], message.data.meta);
  }

  updateObjects(subscription, key, type, objects, meta, appendNew = true) {
    if (meta && meta.total && meta.current && meta.current < meta.total) {
      // Load next page
      this.subscriptionTimeouts.push(setTimeout(() => subscription.perform(key, { page: meta.current + 1 }), 500));
    }
    const existingObjects = this.state[type] || [];
    _.each(objects, (object) => {
      const existing = _.find(existingObjects, { id: object.id });
      if (!existing && appendNew) { existingObjects.push(object); return; }
      const index = _.findIndex(existingObjects, { id: object.id });
      existingObjects[index] = _.extend({}, existing, object);
    });
    this.setState({ [type]: existingObjects });
  }

  disconnectChannels() {
    _.each(this.subscriptionTimeouts, t => clearTimeout(t));
    _.each(this.subscriptions, s => s.unsubscribe());
    this.subscriptionTimeouts = [];
    this.subscriptions = [];
  }

  connectChannel(params, methods) {
    this.subscriptionTimeouts.push(setTimeout(() => {
      this.subscriptions.push(cable.subscriptions.create(params, {
        connected: this.onChannelConnected.bind(this, this.subscriptions.length, methods),
        received: this.onChannelMessageReceived.bind(this, this.subscriptions.length),
      }));
    }, _.random(0, 1, true) * 1000));
  }

  render() {
    const { clientId, planId } = this.props;
    return (
      <div className="gmap">
        <Filters onFiltersChanged={this.onFiltersChanged} />
        <PlansMap
          mapType={this.state.mapType}
          zoom={this.state.zoom}
          onLoad={this.onLoad}
          onClick={this.onClick}
          onZoomChanged={this.onZoomChanged}
        >
          <StopMarkers
            stops={this.state.stops}
            onClick={this.onStopClick}
            overlayView={this.state.overlayView}
            selectedId={this.state.currentObject && this.state.currentObject.kind === 'stop' ? this.state.currentObject.id : null}
            kinds={_.get(this.state, 'filters.stopKinds')}
            stoppableAddresses={this.state.stoppableAddresses}
          />
          <AddressMarkers
            clientId={clientId}
            planId={planId}
            onClick={this.onAddressClick}
            selectedId={this.state.currentObject && this.state.currentObject.kind === 'address' ? this.state.currentObject.id : null}
            overlayView={this.state.overlayView}
            grades={_.get(this.state, 'filters.grades')}
            students={this.state.students}
            stops={this.state.stops}
            stopKinds={_.get(this.state, 'filters.stopKinds')}
            schools={this.state.schools}
            stoppableAddresses={this.state.stoppableAddresses}
            date={moment($('input#filter-date').val(), 'DD.MM.YYYY')}
            times={_.get(this.state, 'filters.times')}
          />
          <JourneyTemplatePolylines
            journeyTemplates={this.state.journeyTemplates || []}
            onClick={this.onJourneyTemplateClick}
            onClickCapture={this.onClickCapture}
            onClickRelease={this.onClickRelease}
            zoom={this.state.zoom}
            selectedId={this.state.currentObject && this.state.currentObject.kind === 'journey_template' ? this.state.currentObject.id : null}
          />
          <SchoolMarkers
            schools={this.state.schools}
            onClick={this.onSchoolClick}
            selectedId={this.state.currentObject && this.state.currentObject.kind === 'school' ? this.state.currentObject.id : null}
          />
          <DepotMarkers
            depots={this.state.depots}
            onClick={this.onDepotClick}
            selectedId={this.state.currentObject && this.state.currentObject.kind === 'depot' ? this.state.currentObject.id : null}
          />
        </PlansMap>
      </div>
    );
  }
}

Plans.defaultProps = {
  planId: null,
  mapBounds: null,
};

Plans.propTypes = {
  planId: PropTypes.number,
  mapBounds: PropTypes.shape({
    north: PropTypes.number,
    south: PropTypes.number,
    east: PropTypes.number,
    west: PropTypes.number,
  }),
  simulatedAt: PropTypes.string.isRequired,
  clientId: PropTypes.number.isRequired,
};

function unmountComponent() {
  const $mapsContainer = $('#map-network-manage');
  if (!$mapsContainer.length) { return; }
  ReactDOM.unmountComponentAtNode($mapsContainer[0]);
}

$(document).on('turbolinks:before-render', unmountComponent);
$(document).on('ready turbolinks:load', () => {
  const $mapsContainer = $('#map-network-manage');
  if (!$mapsContainer.length) { return; }

  const $page = $('.page-networks');
  const networkId = $('#network-id').data('network-id');

  unmountComponent();
  ReactDOM.render(
    <Plans
      planId={$page.data('plan-id') || null}
      simulatedAt={$page.data('plan-simulated-at')}
      clientId={$page.data('client-id')}
      mapBounds={$page.data('map-bounds') || null}
      networkId={networkId}
    />, $mapsContainer[0]);

  $('.gmap-legend-controls').find('.hide-legend, .show-legend').off('click').on('click', () => $('.gmap-block-legend').toggleClass('hide'));
  $('.btn-sim-minimize, .btn-sim-maximize').off('click').on('click', () => $('.simulation-wrapper').toggleClass('minimize'));
});
